export const STRATEGIES_CONFIG_RESPONSE = {
	'resultMap': {
		'REPORT': [
			{
				'data': {
					'strategies': [
						{
							'priority': 1,
							'strategyId': 'enhanceReturns_wholePortfolio_moderate_privateMarkets',
							'strategyName': 'Private Markets',
							'group': 'Whole Portfolio',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks'],
									'weight': 10
								},
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 10
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'CREDX@09259W108@US09259W1080',
									'globalId': 'Z92TB9X43',
									'morningstarSecId': 'F000013FD6',
									'assetType': 'Fund',
									'weight': 10,
									'displayAssetClassName': 'US Large Cap Stocks'
								},
								{
									'identifier': 'IZRL@00214Q609@US00214Q6098',
									'globalId': 'Z92HJE2N2',
									'morningstarSecId': 'F00000WG05',
									'assetType': 'Fund',
									'weight': 10,
									'displayAssetClassName': 'Core Bonds'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 1,
							'strategyId': 'enhanceReturns_wholePortfolio_conservative_privateMarkets',
							'strategyName': 'Private Markets',
							'group': 'Whole Portfolio',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks'],
									'weight': 5
								},
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 15
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'CREDX@09259W108@US09259W1080',
									'globalId': 'Z92TB9X43',
									'morningstarSecId': 'F000013FD6',
									'assetType': 'Fund',
									'weight': 15,
									'displayAssetClassName': 'US Large Cap Stocks'
								},
								{
									'identifier': 'IZRL@00214Q609@US00214Q6098',
									'globalId': 'Z92HJE2N2',
									'morningstarSecId': 'F00000WG05',
									'assetType': 'Fund',
									'weight': 5,
									'displayAssetClassName': 'Core Bonds'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 1,
							'strategyId': 'enhanceReturns_wholePortfolio_aggressive_privateMarkets',
							'strategyName': 'Private Markets',
							'group': 'Whole Portfolio',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks'],
									'weight': 15
								},
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 5
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'CREDX@09259W108@US09259W1080',
									'globalId': 'Z92TB9X43',
									'morningstarSecId': 'F000013FD6',
									'assetType': 'Fund',
									'weight': 5,
									'displayAssetClassName': 'US Large Cap Stocks'
								},
								{
									'identifier': 'IZRL@00214Q609@US00214Q6098',
									'globalId': 'Z92HJE2N2',
									'morningstarSecId': 'F00000WG05',
									'assetType': 'Fund',
									'weight': 15,
									'displayAssetClassName': 'Core Bonds'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 2,
							'strategyId': 'enhanceReturns_Fixed_Income_a_Private_Alts',
							'strategyName': 'Private Credit & Alternatives',
							'group': 'Fixed Income',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/275463/', 'resourceValue': 'Systematic Multi-Strategy Fund' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 15
								},
								{
									'subAssetClasses': ['creditBonds'],
									'weight': 5
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'CREDX@09259W108@US09259W1080',
									'globalId': 'Z92TB9X43',
									'morningstarSecId': 'F000013FD6',
									'assetType': 'Fund',
									'weight': 10,
									'displayAssetClassName': 'US Large Cap Stocks'
								},
								{
									'identifier': 'BIMBX@09260C307@US09260C3079',
									'globalId': 'Z91SR1CW7',
									'morningstarSecId': 'F00000VDR5',
									'assetType': 'Fund',
									'weight': 10,
									'displayAssetClassName': 'Credit Bonds'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 2,
							'strategyId': 'enhanceReturns_Fixed_Income_b_Private_Alts',
							'strategyName': 'Private Credit & Alternatives',
							'group': 'Fixed Income',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/275463/', 'resourceValue': 'Systematic Multi-Strategy Fund' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 7.5
								},
								{
									'subAssetClasses': ['creditBonds'],
									'weight': 2.5
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'CREDX@09259W108@US09259W1080',
									'globalId': 'Z92TB9X43',
									'morningstarSecId': 'F000013FD6',
									'assetType': 'Fund',
									'weight': 5,
									'displayAssetClassName': 'US Large Cap Stocks'
								},
								{
									'identifier': 'BIMBX@09260C307@US09260C3079',
									'globalId': 'Z91SR1CW7',
									'morningstarSecId': 'F00000VDR5',
									'assetType': 'Fund',
									'weight': 5,
									'displayAssetClassName': 'Credit Bonds'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 3,
							'strategyId': 'enhanceReturns_Equity_a_Private_LargeCap_Equity',
							'strategyName': 'Private Equity & Factors',
							'group': 'Equity',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks', 'usMidCapStocks', 'usSmallCapStocks'],
									'weight': 20
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'IZRL@00214Q609@US00214Q6098',
									'globalId': 'Z92HJE2N2',
									'morningstarSecId': 'F00000WG05',
									'assetType': 'Fund',
									'weight': 12,
									'displayAssetClassName': 'International/Global Fixed Income'
								},
								{
									'identifier': 'MTUM@46432F396@US46432F3964',
									'globalId': 'Z91CWM896',
									'morningstarSecId': 'F00000PF2S',
									'assetType': 'Fund',
									'weight': 8,
									'displayAssetClassName': 'International/Global Fixed Income'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 3,
							'strategyId': 'enhanceReturns_Equity_b_Private_LargeCap_Equity',
							'strategyName': 'Private Equity & Factors',
							'group': 'Equity',
							'goals': ['increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks', 'usMidCapStocks', 'usSmallCapStocks'],
									'weight': 10
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'IZRL@00214Q609@US00214Q6098',
									'globalId': 'Z92HJE2N2',
									'morningstarSecId': 'F00000WG05',
									'assetType': 'Fund',
									'weight': 6,
									'displayAssetClassName': 'International/Global Fixed Income'
								},
								{
									'identifier': 'MTUM@46432F396@US46432F3964',
									'globalId': 'Z91CWM896',
									'morningstarSecId': 'F00000PF2S',
									'assetType': 'Fund',
									'weight': 4,
									'displayAssetClassName': 'International/Global Fixed Income'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 4,
							'strategyId': 'strategyTwo',
							'strategyName': 'Test Strategy 1',
							'group': 'Test1',
							'goals': ['generateIncome', 'reduceRisk', 'increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['coreBonds'],
									'weight': 15
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'IBND@78464A151@US78464A1512',
									'globalId': 'Z915NXQ06',
									'morningstarSecId': 'F00000GX0C',
									'assetType': 'Fund',
									'weight': 15,
									'displayAssetClassName': 'International/Global Fixed Income'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						},
						{
							'priority': 5,
							'strategyId': 'strategyThree',
							'strategyName': 'Test Strategy 2',
							'group': 'Test2',
							'goals': ['generateIncome', 'increaseReturn'],
							'relatedResources': [
								{ 'page': 'step-2', 'resourceId': 'res1', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments', 'resourceValue': 'Learn more about alternatives' },
								{ 'page': 'step-2', 'resourceId': 'res2', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/art-of-alternative-investment', 'resourceValue': 'Master the art of alts' },
								{ 'page': 'step-2', 'resourceId': 'res3', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/market-commentary/alternatives-in-focus-quarterly-commentary.pdf', 'resourceValue': 'Outlook: Alternatives in focus' },
								{ 'page': 'step-2', 'resourceId': 'res4', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/literature/investor-education/private-credit-primer-stamped.pdf', 'resourceValue': 'Introduction to private credit and direct lending' },
								{ 'page': 'step-3', 'resourceId': 'resA', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/products/blackrock-credit-strategies-fund', 'resourceValue': 'Credit without boundaries' },
								{ 'page': 'step-3', 'resourceId': 'resB', 'resourceLink': 'https://www.blackrock.com/us/financial-professionals/investment-strategies/private-equity', 'resourceValue': 'Private equity unleashed' }
							],
							'sourceFrom': [
								{
									'subAssetClasses': ['usLargeCapStocks'],
									'weight': 10
								}
							],
							'securitiesFrom': [],
							'securitiesTo': [
								{
									'identifier': 'IVV@464287200@US4642872000',
									'globalId': 'Z915MBY06',
									'morningstarSecId': 'FEUSA0000E',
									'assetType': 'Fund',
									'weight': 10,
									'displayAssetClassName': 'International/Global Fixed Income'
								}
							],
							'tips': ['HDMAFRAMEWORK', 'HDMASCREENING']
						}
					]
				}
			}
		]
	}
};
